import { Icon } from "materia"
import { useTranslation } from "react-i18next"
import s from "./HowToDownloadText.module.scss"

export const HowToDownloadText = ({ isVisible }: { isVisible: boolean }) => {
  const { t } = useTranslation()

  if (!isVisible) return null

  return (
    <div className={s.howToDownloadText}>
      <div className={s.howToDownloadText__circle}>
        <Icon icon="InfoCircle" size="large" />
      </div>
      <div className={s.howToDownloadText__description}>
        {t("helpText.DESCRIPTION")}
      </div>
    </div>
  )
}
